import React, { Component } from 'react';
import {
  setHoveredSearchResult,
  setActiveStyle as setActiveStyleAction,
  clickedDelomraade,
  clickedByggefelt,
} from '../../store/actions';
import { connect } from 'react-redux';
import mapboxgl, {
  Map,
  PaddingOptions,
  Style,
  MapboxGeoJSONFeature,
  Marker,
  NavigationControl,
  ScaleControl,
} from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import './mapbox-override.css';
import {
  LokalPlan,
  LokalPlanDelOmraade,
  Byggefelt,
  PlanSource,
  SelectedLokalPlan,
  SelectedLokalPlanDelOmraade,
  SelectedByggefelt,
  SelectedLokalPlanHistorisk,
  HoveredLokalPlan,
  HoveredLokalPlanDelOmraade,
  HoveredByggefelt,
  GetFilter,
  getPlanensAlderPaint,
  getEtagerByggeHojdePaint,
  getGenerelAnvendelsePaint,
  LokalPlanHistorisk,
  getBygOmfangPaint,
} from './MapLayers';
import { PositionProperty } from 'csstype';
import { arrayStringToArray } from '../../util';
import { ILokalplan } from '../../Interfaces/ILokalplan';
import boundingBox from '@turf/bbox';
import buffer from '@turf/buffer';
import * as reproject from 'reproject';
import proj4 from 'proj4';
import diffStyles from './util/diff.js';
import produce from 'immer';
import { BBox, point } from '@turf/helpers';
import centerOfMass from '@turf/center-of-mass';
import { filterLayerByPlanId, filterLayerByPlanIds } from './util/filter';
import { size } from '../../style/util';
import { orderPolygonsByDistanceToPoint } from '../../util/geometry';
import {
  activeStyle as ActiveStyle,
  IAppState,
  IEtagerByggehojdeFilter,
  IBygOmfangFilter,
} from '../../store/interfaces/state';
import { IKommune } from '../../Interfaces/IKommune';
import DisableMap from './DisableMap';
import { ISeptimaSearchResultItem } from '../Sidebars/Search/SeptimaSearch/interfaces';
import {
  defaultPlanAlderFilter,
  defaultBygOmfangFilter,
  defaultEtagerByggeHojdeFilter,
} from '../../store/reducers';

class MapContainer extends Component<MapContainerProps, MapContainerState> {
  map: Map;
  mapContainer: any;
  defaultStyle: Style;
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }
  addDefaultLayers() {
    this.map.addLayer(LokalPlanHistorisk);
    this.map.addLayer(LokalPlan);
    this.map.addLayer(LokalPlanDelOmraade);
    this.map.addLayer(Byggefelt);
    this.map.addLayer(SelectedLokalPlan);
    this.map.addLayer(SelectedLokalPlanHistorisk);
    this.map.addLayer(HoveredLokalPlan);
    this.map.addLayer(HoveredLokalPlanDelOmraade);
    this.map.addLayer(HoveredByggefelt);
    this.map.addLayer(SelectedLokalPlanDelOmraade);
    this.map.addLayer(SelectedByggefelt);
  }
  setMapLayers() {
    const { setStyle } = this.props;
    this.map.addSource('lokalplan', PlanSource);
    this.addDefaultLayers();
    this.defaultStyle = this.map.getStyle();
    setStyle(produce(this.defaultStyle, draft => {}));
  }
  loadHistoriskePlaner() {
    this.props.setHistoriskeLokalplanerLoading(true);
    this.props.setHistoriskeLokalplanerToggled(true);
    this.zoomToFeature(this.props.currentLokalplan.feature);
    this.setState({ loading: true });

    this.map.once('moveend', e => {
      this.checkTilesLoaded(() => {
        this.props.setLokalplanerLoading(false);
        const renderedFeatures = this.map.queryRenderedFeatures();
        let renderedHistoriskeLokalplaner = renderedFeatures
          .filter(r => r.layer.id === LokalPlanHistorisk.id)
          .map(feature => this.createLokalPlanFeature(feature));
        const historiskeLokalplaner: Array<ILokalplan> = [];
        renderedHistoriskeLokalplaner.forEach(p => {
          if (
            historiskeLokalplaner.findIndex(hp => {
              return (
                hp.feature.properties.versionsnr ===
                p.feature.properties.versionsnr
              );
            }) === -1
          ) {
            historiskeLokalplaner.push(p);
          }
        });
        historiskeLokalplaner.sort((a, b) => {
          if (a.feature.properties.datoopdt < b.feature.properties.datoopdt) {
            return -1;
          }
          if (a.feature.properties.datoopdt > b.feature.properties.datoopdt) {
            return 1;
          }
          return 0;
        });
        historiskeLokalplaner.push(this.props.currentLokalplan);

        this.props.setHistoriskeLokalplaner(historiskeLokalplaner);
        this.props.setCurrentHistoriskeLokalplan(historiskeLokalplaner[0]);
        this.props.setHistoriskeLokalplanerLoading(false);
        this.setState({ loading: false });
      });
    });
  }
  onMapLoad(e: any) {
    this.setMapLayers();
    // listeners
    this.map.on('click', this.onMapClick.bind(this));
    this.map.on('moveend', this.onMoveEnd.bind(this));
    this.map.on('mousemove', this.onMouseMove.bind(this));
    this.map.on('dataloading', e => {
      if (e.sourceId === 'lokalplan' && !this.props.lokalplanerLoading) {
        const { setLokalplanerLoading } = this.props;
        setLokalplanerLoading(true);
        this.checkTilesLoaded(() => {
          this.props.setLokalplanerLoading(false);
        });
      }
    });
    (this.map as any).style.sourceCaches['lokalplan']._source.attribution =
      '&copy; ' +
      new Date().getFullYear() +
      ' <a href="https://erhvervsstyrelsen.dk/">Erhvervsstyrelsen</a>, vector tiles by <a href="https://www.septima.dk">Septima P/S/</a>';
  }

  setMarker(punkt) {
    const { marker, setMarker } = this.props;
    if (marker) {
      marker.remove();
    }
    const newMarker = new Marker()
      .setLngLat(punkt.geometry.coordinates)
      .addTo(this.map);
    setMarker(newMarker);
  }
  removeMarker() {
    const { marker, setMarker } = this.props;
    if (marker) {
      marker.remove();
    }
    setMarker(undefined);
  }

  onMapClick(e: any) {
    const {
      currentLokalplan,
      setCurrentLokaplan,
      setCurrentHistoriskeLokalplan,
      setClickedLokalplans,
      setHoveredPlans,
      setClickedDelomraade,
      setClickedByggefelt,
    } = this.props;
    const { point } = e;
    const features = this.map.queryRenderedFeatures(point);
    const clickedLokalplanFeatures = features
      .filter(f => f.layer.id === 'lokalplan')
      .map(f => this.createLokalPlanFeature(f));
    // Sometimes a render-error causes mapbox to think we
    // clicked the same lokalplan multiple times:
    let lokalplanFeatures: ILokalplan[] = [];
    clickedLokalplanFeatures.forEach(lokalplan => {
      if (
        lokalplanFeatures.findIndex(l => {
          return (
            l.feature.properties.planid === lokalplan.feature.properties.planid
          );
        }) === -1
      ) {
        lokalplanFeatures.push(lokalplan);
      }
    });
    const clickedDelomraade = features.find(
      f => f.layer.id === 'lokalplandelomraade-hovered'
    );
    const clickedByggefelt = features.find(
      f => f.layer.id === 'byggefelt-hovered'
    );
    if (!currentLokalplan && lokalplanFeatures.length) {
      setClickedLokalplans(lokalplanFeatures);
      setCurrentLokaplan(lokalplanFeatures[0]);
    } else if (currentLokalplan && (clickedDelomraade || clickedByggefelt)) {
      if (clickedDelomraade) {
        setClickedDelomraade(clickedDelomraade.properties.planid);
      }
      if (clickedByggefelt) {
        setClickedByggefelt(clickedByggefelt.properties.planid);
      }
      // const currentLokalPlanDelomraade = features.filter(f => f.layer.id === 'delomraade').find(d=>d.properties.)
    } else {
      setClickedLokalplans([]);
      setHoveredPlans([]);
      setCurrentLokaplan(undefined);
      setCurrentHistoriskeLokalplan(undefined);
    }
  }
  onMoveEnd(e: any) {
    localStorage.setItem('mapcenter', JSON.stringify(e.target.getCenter()));
  }

  onMouseMove(e: any) {
    const {
      currentLokalplan,
      currentHistoriskeLokalplan,
      setHoveredPlans,
      lokalPlanerMapSearchResult,
      setHoveredLokalPlanerMapSearchResult,
      searchToggled,
    } = this.props;
    const currentPlan = currentHistoriskeLokalplan
      ? currentHistoriskeLokalplan
      : currentLokalplan
      ? currentLokalplan
      : undefined;
    const features = this.map.queryRenderedFeatures(e.point);
    const lokalplanFeatures = features.filter(f => f.layer.id === 'lokalplan');
    if (searchToggled && !currentPlan) {
      const hoveredPlanIds = lokalplanFeatures.map(f => f.properties.planid);
      const searchResultIds = lokalPlanerMapSearchResult.map(
        sr => sr.feature.properties.planid
      );
      const hoveredPlanInSearchResult = hoveredPlanIds.find(
        hp => searchResultIds.indexOf(hp) > -1
      );
      setHoveredLokalPlanerMapSearchResult(
        hoveredPlanInSearchResult ? hoveredPlanInSearchResult : -1
      );
    }
    const delomraader = currentPlan
      ? features.filter(
          f =>
            f.layer.id === 'lokalplandelomraade' &&
            f.properties.lokplan_id ===
              currentLokalplan.feature.properties.planid
        )
      : [];
    const byggefelter = currentPlan
      ? features.filter(
          f =>
            f.layer.id === 'byggefelt' &&
            f.properties.lokplan_id === currentPlan.feature.properties.planid
        )
      : [];
    if (!currentPlan && lokalplanFeatures.length) {
      this.map.getCanvas().style.cursor = 'pointer';
    } else {
      this.map.getCanvas().style.cursor = '';
      const hoveredPlans = [];
      if (delomraader.length) {
        this.map.getCanvas().style.cursor = 'pointer';
        delomraader.forEach(f => hoveredPlans.push(f.properties.planid));
      }
      if (byggefelter.length) {
        this.map.getCanvas().style.cursor = 'pointer';
        byggefelter.forEach(f => hoveredPlans.push(f.properties.planid));
      }
      setHoveredPlans(hoveredPlans);
    }
  }

  zoomToBounds(bbox: BBox): void {
    const { small } = size;
    const { innerWidth, innerHeight } = window;
    const padding: PaddingOptions = {
      top: innerWidth < small ? 125 : 150,
      bottom: innerWidth < small ? innerHeight * 0.4 + 125 : 150,
      left: innerWidth < small ? 10 : 50,
      right: innerWidth < small ? 10 : 470,
    };
    this.map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]], {
      padding,
    });
  }
  zoomToFeature(feature: MapboxGeoJSONFeature) {
    const {
      minlng_100k,
      minlat_100k,
      maxlng_100k,
      maxlat_100k,
    } = feature.properties;
    let bounds: BBox =
      minlng_100k && minlat_100k && maxlng_100k && maxlat_100k
        ? [
            minlng_100k / 100000,
            minlat_100k / 100000,
            maxlng_100k / 100000,
            maxlat_100k / 100000,
          ]
        : boundingBox(feature.geometry);
    this.zoomToBounds(bounds);
  }

  createLokalPlanFeature(feature): ILokalplan {
    if (!feature) return undefined;
    let lokalPlanFeature: ILokalplan;
    const renderedFeatures = this.map.queryRenderedFeatures();

    const delomraadeIds = arrayStringToArray(feature.properties.delomraader);
    const delomraadeKeys = new Set();
    const lokalPlanDelomraader = renderedFeatures
      .filter(
        f =>
          f.properties.object_type === 'lokalplandelomraade' &&
          delomraadeIds.includes(f.properties.planid.toString()) &&
          f.properties.versionsnr === feature.properties.versionsnr
      )
      .filter(plan => {
        const { planid } = plan.properties;
        if (delomraadeKeys.has(planid)) {
          return false;
        }
        delomraadeKeys.add(planid);
        return true;
      });

    const byggefeltIds = arrayStringToArray(feature.properties.byggefelter);
    const byggefeltKeys = new Set();
    const byggefelter = renderedFeatures
      .filter(
        f =>
          f.properties.object_type === 'byggefelt' &&
          byggefeltIds.includes(f.properties.planid.toString()) &&
          f.properties.versionsnr === feature.properties.versionsnr
      )
      .filter(plan => {
        const { planid } = plan.properties;
        if (byggefeltKeys.has(planid)) {
          return false;
        }
        byggefeltKeys.add(planid);
        return true;
      });

    lokalPlanFeature = {
      feature: feature,
      delomraader: lokalPlanDelomraader,
      byggefelter,
    };
    return lokalPlanFeature;
  }
  selectLokalplan(lokalplan: ILokalplan) {
    const { setStyle, style } = this.props;
    let selectedByggefeltPlanIds: any = '';
    let selectedLokalPlanDelOmraadeIds: any = '';
    if (lokalplan) {
      selectedLokalPlanDelOmraadeIds = [
        ...new Set(lokalplan.delomraader.map(b => b.properties.planid)),
      ];
      selectedByggefeltPlanIds = [
        ...new Set(lokalplan.byggefelter.map(b => b.properties.planid)),
      ];
      this.zoomToFeature(lokalplan.feature);
    }

    // vis valgte features:
    const filter = [
      'all',
      ['==', 'planid', lokalplan ? lokalplan.feature.properties.planid : ''],
      ['==', 'aktuel', true],
    ];

    this.map.setFilter(SelectedLokalPlan.id, filter);
    this.map.setFilter(
      SelectedByggefelt.id,
      selectedByggefeltPlanIds.length
        ? [
            'all',
            ['match', ['get', 'planid'], selectedByggefeltPlanIds, true, false],
            [
              'match',
              ['get', 'versionsnr'],
              lokalplan.feature.properties.versionsnr,
              true,
              false,
            ],
          ]
        : ['==', 'planid', '']
    );

    this.map.setFilter(
      SelectedLokalPlanDelOmraade.id,
      selectedLokalPlanDelOmraadeIds.length
        ? [
            'all',
            [
              'match',
              ['get', 'planid'],
              selectedLokalPlanDelOmraadeIds,
              true,
              false,
            ],
            [
              'match',
              ['get', 'versionsnr'],
              lokalplan.feature.properties.versionsnr,
              true,
              false,
            ],
          ]
        : ['==', 'planid', '']
    );

    setStyle(
      lokalplan
        ? produce(style, newStyle => {
            newStyle.layers.forEach(l => {
              if (
                l.id === LokalPlan.id ||
                l.id === LokalPlanDelOmraade.id ||
                l.id === Byggefelt.id
              ) {
                l.paint['fill-opacity'] = 0.05;
              }
              if (l.id === SelectedLokalPlan.id) {
                l.paint['fill-opacity'] = 0.3;
              }
              if (l.id === SelectedLokalPlanHistorisk.id) {
                l.paint['fill-opacity'] = 0;
              }
            });
          })
        : produce(style, newStyle => {
            newStyle.layers.forEach(l => {
              if (l.id === LokalPlan.id) {
                l.paint['fill-opacity'] = LokalPlan.paint['fill-opacity'];
              }
              if (l.id === 'lokalplandelomraade' || l.id === 'byggefelt') {
                l.paint['fill-opacity'] =
                  LokalPlanDelOmraade.paint['fill-opacity'];
              }
            });
          })
    );

    //Historiske plane
    this.map.setFilter(LokalPlanHistorisk.id, [
      'all',
      ['==', 'planid', lokalplan ? lokalplan.feature.properties.planid : ''],
      ['==', 'aktuel', false],
    ]);
  }

  selectHistoriskLokalplan(historiskLokalplan: ILokalplan) {
    const { setStyle, style } = this.props;
    let selectedByggefeltPlanIds: any = '';
    let selectedLokalPlanDelOmraadeIds: any = '';
    if (historiskLokalplan) {
      selectedLokalPlanDelOmraadeIds = [
        ...new Set(
          historiskLokalplan.delomraader.map(b => b.properties.planid)
        ),
      ];
      selectedByggefeltPlanIds = [
        ...new Set(
          historiskLokalplan.byggefelter.map(b => b.properties.planid)
        ),
      ];
      this.zoomToFeature(historiskLokalplan.feature);
    }

    // vis valgte features:
    const filter = [
      'all',
      [
        '==',
        'planid',
        historiskLokalplan ? historiskLokalplan.feature.properties.planid : '',
      ],
      [
        '==',
        'versionsnr',
        historiskLokalplan
          ? historiskLokalplan.feature.properties.versionsnr
          : '',
      ],
    ];

    this.map.setFilter(SelectedLokalPlanHistorisk.id, filter);
    this.map.setFilter(
      SelectedByggefelt.id,
      // ['==', 'planid', '']
      selectedByggefeltPlanIds.length
        ? [
            'all',
            ['match', ['get', 'planid'], selectedByggefeltPlanIds, true, false],
            [
              'match',
              ['get', 'versionsnr'],
              historiskLokalplan.feature.properties.versionsnr,
              true,
              false,
            ],
          ]
        : ['==', 'planid', '']
    );
    this.map.setFilter(
      SelectedLokalPlanDelOmraade.id,
      // ['==', 'planid', '']
      selectedLokalPlanDelOmraadeIds.length
        ? [
            'all',
            [
              'match',
              ['get', 'planid'],
              selectedLokalPlanDelOmraadeIds,
              true,
              false,
            ],
            [
              'match',
              ['get', 'versionsnr'],
              historiskLokalplan.feature.properties.versionsnr,
              true,
              false,
            ],
          ]
        : ['==', 'planid', '']
    );

    setStyle(
      historiskLokalplan
        ? produce(style, newStyle => {
            newStyle.layers.forEach(l => {
              if (
                l.id === 'lokalplan' ||
                l.id === 'lokalplandelomraade' ||
                l.id === 'byggefelt' ||
                l.id === SelectedLokalPlan.id
              ) {
                l.paint['fill-opacity'] = 0.05;
              }
              if (l.id === SelectedLokalPlanHistorisk.id) {
                l.paint['fill-opacity'] = 0.3;
              }
            });
          })
        : produce(style, newStyle => {
            newStyle.layers.forEach(l => {
              if (l.id === 'lokalplan') {
                l.paint['fill-opacity'] = LokalPlan.paint['fill-opacity'];
              }
              if (l.id === 'lokalplandelomraade' || l.id === 'byggefelt') {
                l.paint['fill-opacity'] =
                  LokalPlanDelOmraade.paint['fill-opacity'];
              }
            });
          })
    );
  }
  setupMap() {
    const { longitude, latitude, zoom, token } = this.props;
    const storedCenter = localStorage.getItem('mapcenter');
    mapboxgl.accessToken = token;
    this.map = new mapboxgl.Map({
      container: this.mapContainer,
      style:
        'https://api.maptiler.com/maps/1f79a7b5-9424-43f3-9179-cd919d206533/style.json?key=Gw5WNrAaw6tgSh1dLDg8',
      center: storedCenter
        ? [JSON.parse(storedCenter).lng, JSON.parse(storedCenter).lat]
        : [longitude, latitude],
      zoom: zoom,
      maxBounds: [[6.19, 54], [16.6, 59]],
      minZoom: 7,
    });
    this.map.addControl(
      new NavigationControl({ showCompass: false }),
      'bottom-left'
    );
    this.map.addControl(new ScaleControl(), 'bottom-right');
    this.map.on('load', this.onMapLoad.bind(this));
  }

  componentDidMount() {
    this.setupMap();
  }
  componentDidUpdate(prevProps: MapContainerProps) {
    const {
      style,
      setStyle,
      activeStyle,
      setActiveStyle,
      toggledAnvgens,
      toggledAnvspecs,
      planAlderFilter,
      bygOmfangFilter,
      etagerByggeHojde,
      searchToggled,
      currentLokalplan,
      currentHistoriskeLokalplan,
      hoveredPlans,
      searchResult,
      setLokalPlanerMapSearchResult,
      hoveredLokalPlanerMapSearchResult,
      selectedKommune,
      triggerHistoriskeLokalplaner,
    } = this.props;

    // this.state.style:
    const changes = diffStyles(prevProps.style, style);
    changes.forEach(change => {
      if (change.command === 'updateSource') {
        // This is a workaround patch for updateSource not being
        // low level enough for a generic apply command - dff.js has also
        // been patched.
        (this.map.getSource(change.args[0]) as any).setData(
          change.args[1].data
        );
      } else {
        this.map[change.command].apply(this.map, change.args);
      }
    });

    // filters
    if (
      prevProps.toggledAnvgens.length !== toggledAnvgens.length ||
      prevProps.toggledAnvspecs.length !== toggledAnvspecs.length ||
      prevProps.planAlderFilter !== planAlderFilter ||
      prevProps.bygOmfangFilter !== bygOmfangFilter ||
      prevProps.etagerByggeHojde !== etagerByggeHojde
    ) {
      const filter = GetFilter(
        LokalPlan.id,
        toggledAnvgens,
        toggledAnvspecs,
        planAlderFilter,
        bygOmfangFilter,
        etagerByggeHojde
      );
      this.map.setFilter(LokalPlan.id, filter);
    }
    if (prevProps.toggledAnvgens.length !== toggledAnvgens.length) {
      setActiveStyle(ActiveStyle.generelAnvendelse);
    }
    if (
      prevProps.etagerByggeHojde !== etagerByggeHojde &&
      etagerByggeHojde !== defaultEtagerByggeHojdeFilter
    ) {
      setActiveStyle(ActiveStyle.etagerByggeHojde);
    }
    if (
      prevProps.bygOmfangFilter !== bygOmfangFilter &&
      bygOmfangFilter !== defaultBygOmfangFilter
    ) {
      setActiveStyle(ActiveStyle.bygOmfang);
    }
    if (
      prevProps.planAlderFilter !== planAlderFilter &&
      planAlderFilter !== defaultPlanAlderFilter
    ) {
      setActiveStyle(ActiveStyle.planensAlder);
    }

    // activeStyle
    if (
      prevProps.activeStyle !== activeStyle ||
      prevProps.etagerByggeHojde !== etagerByggeHojde ||
      prevProps.bygOmfangFilter !== bygOmfangFilter ||
      prevProps.planAlderFilter !== planAlderFilter
    ) {
      switch (activeStyle) {
        case ActiveStyle.generelAnvendelse:
          setStyle(
            produce(this.defaultStyle, newStyle => {
              newStyle.layers.forEach(l => {
                if (l.id === 'lokalplan') {
                  l.paint = getGenerelAnvendelsePaint() as any;
                }
              });
            })
          );
          break;
        case ActiveStyle.planensAlder:
          setStyle(
            produce(this.defaultStyle, newStyle => {
              newStyle.layers.forEach(l => {
                if (l.id === 'lokalplan') {
                  l.paint = getPlanensAlderPaint(
                    planAlderFilter[0],
                    planAlderFilter[1]
                  ) as any;
                }
              });
            })
          );
          break;
        case ActiveStyle.bygOmfang:
          setStyle(
            produce(this.defaultStyle, newStyle => {
              newStyle.layers.forEach(l => {
                if (l.id === 'lokalplan') {
                  l.paint = getBygOmfangPaint(bygOmfangFilter) as any;
                }
              });
            })
          );
          break;
        case ActiveStyle.etagerByggeHojde:
          setStyle(
            produce(this.defaultStyle, newStyle => {
              newStyle.layers.forEach(l => {
                if (l.id === 'lokalplan') {
                  l.paint = getEtagerByggeHojdePaint(etagerByggeHojde) as any;
                }
              });
            })
          );
          break;
        default:
          break;
      }
    }

    // this.state.searchToggled:
    if (prevProps.searchToggled && !searchToggled) {
      this.removeMarker();
    }
    if (prevProps.currentLokalplan !== currentLokalplan) {
      this.selectLokalplan(currentLokalplan);
    }
    if (prevProps.currentHistoriskeLokalplan !== currentHistoriskeLokalplan) {
      if (
        currentHistoriskeLokalplan &&
        !currentHistoriskeLokalplan.feature.properties.aktuel
      ) {
        this.selectHistoriskLokalplan(currentHistoriskeLokalplan);
      } else if (currentLokalplan) {
        this.selectLokalplan(currentLokalplan);
      }
      if (!currentHistoriskeLokalplan) {
        this.map.setFilter(SelectedLokalPlanHistorisk.id, ['==', 'planid', '']);
      }
    }
    const currentPlan = currentHistoriskeLokalplan
      ? currentHistoriskeLokalplan
      : currentLokalplan
      ? currentLokalplan
      : undefined;
    // hoveredPlans:
    if (prevProps.hoveredPlans !== hoveredPlans) {
      // TODO: current historisk lokalplan
      const delomraader = currentPlan
        ? currentPlan.delomraader.filter(
            f => hoveredPlans.indexOf(f.properties.planid) > -1
          )
        : [];
      const byggefelter = currentPlan
        ? currentLokalplan.byggefelter.filter(
            f => hoveredPlans.indexOf(f.properties.planid) > -1
          )
        : [];
      this.map.setFilter(
        HoveredLokalPlanDelOmraade.id,
        filterLayerByPlanIds(
          LokalPlanDelOmraade.id,
          delomraader.length ? delomraader.map(f => f.properties.planid) : [-1],
          currentPlan.feature.properties.versionsnr
        )
      );
      this.map.setFilter(
        HoveredByggefelt.id,
        filterLayerByPlanIds(
          Byggefelt.id,
          byggefelter.length ? byggefelter.map(f => f.properties.planid) : [-1],
          currentPlan.feature.properties.versionsnr
        )
      );
    }

    // searchResult:
    if (prevProps.searchResult !== searchResult) {
      if (searchResult) {
        const { geometry } = searchResult;
        let punkt;
        const epsg25832 = proj4.Proj(
          '+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs'
        );
        if (geometry.type === 'Point') {
          const { coordinates } = geometry;
          const punktMerkator = point(coordinates);
          punkt = reproject.toWgs84(punktMerkator, epsg25832);
        } else if (
          geometry.type === 'Polygon' ||
          geometry.type === 'MultiPolygon'
        ) {
          // const poly = polygon()
          const center = centerOfMass(geometry);
          punkt = reproject.toWgs84(center, epsg25832);
        } else {
          console.log(geometry);
        }
        if (!punkt) return;
        const punktBuffer = buffer(punkt, 1);
        const koordBufferBbox = boundingBox(punktBuffer);
        this.zoomToBounds(koordBufferBbox);
        this.setMarker(punkt);
        this.setState({ loading: true });
        this.map.once('moveend', e => {
          this.checkTilesLoaded(() => {
            const closestFeatures = orderPolygonsByDistanceToPoint(
              this.map.queryRenderedFeatures(undefined, {
                layers: [LokalPlan.id],
              }),
              punkt
            );
            setLokalPlanerMapSearchResult(
              closestFeatures.map(feature =>
                this.createLokalPlanFeature(feature)
              )
            );
            this.setState({ loading: false });
          });
        });
      }
    }

    //hoveredLokalPlanerMapSearchResult
    if (
      prevProps.hoveredLokalPlanerMapSearchResult !==
      hoveredLokalPlanerMapSearchResult
    ) {
      this.map.setFilter(
        HoveredLokalPlan.id,
        filterLayerByPlanId(LokalPlan.id, hoveredLokalPlanerMapSearchResult)
      );
    }

    //selectedKommune
    if (
      (!prevProps.selectedKommune && selectedKommune) ||
      (prevProps.selectedKommune &&
        selectedKommune &&
        prevProps.selectedKommune.kode !== selectedKommune.kode)
    ) {
      const { bbox } = selectedKommune;
      this.map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]]);
    }

    if (
      prevProps.triggerHistoriskeLokalplaner !== triggerHistoriskeLokalplaner
    ) {
      if (triggerHistoriskeLokalplaner) {
        this.loadHistoriskePlaner();
      }
    }
  }
  checkTilesLoaded(callback) {
    if (!this.map.areTilesLoaded()) {
      setTimeout(() => {
        this.checkTilesLoaded(callback);
      }, 1000);
    } else {
      callback();
    }
  }

  render() {
    const style = {
      position: 'absolute' as PositionProperty,
      top: 0,
      bottom: 0,
      width: '100%',
      filter: this.state.loading ? 'grayscale(80%)' : undefined,
    };
    return (
      <div>
        <div style={style} ref={el => (this.mapContainer = el)} />
        <DisableMap disable={this.state.loading} />
      </div>
    );
  }
}

const mapStateToProps = (state: IAppState) => {
  const { searchResult, lokalplaner, filters, style } = state;
  return {
    hoveredLokalPlanerMapSearchResult: searchResult.hovered,
    toggledAnvgens: filters.generelAnvendelse,
    toggledAnvspecs: filters.specifikAnvendelse,
    planAlderFilter: filters.planensAlder,
    bygOmfangFilter: filters.bygOmfang,
    etagerByggeHojde: filters.etagerByggeHojde,
    activeStyle: style.activeStyle,
    triggerHistoriskeLokalplaner: lokalplaner.triggerHistoriskeLokalplaner,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setHoveredLokalPlanerMapSearchResult: planid => {
      dispatch(setHoveredSearchResult(planid));
    },
    setActiveStyle: activeStyle => {
      dispatch(setActiveStyleAction(activeStyle));
    },
    setClickedDelomraade: id => {
      dispatch(clickedDelomraade(id));
    },
    setClickedByggefelt: id => {
      dispatch(clickedByggefelt(id));
    },
  };
};
interface MapContainerState {
  loading: boolean;
}
interface MapContainerProps {
  longitude: number;
  latitude: number;
  zoom: number;
  token: string;
  currentLokalplan?: ILokalplan;
  setCurrentLokaplan: Function;
  clickedLokalplans?: Array<ILokalplan>;
  setClickedLokalplans: Function;
  style: Style;
  setStyle: Function;
  hoveredPlans: Array<number>; // delområder og byggefelter, til LokalplanSidebar
  setHoveredPlans: Function;
  toggledAnvgens: Array<number>;
  toggledAnvspecs: Array<number>;
  planAlderFilter: Array<number>;
  marker?: Marker;
  setMarker: Function;
  searchToggled: Boolean;
  searchResult: ISeptimaSearchResultItem;
  lokalPlanerMapSearchResult: Array<ILokalplan>;
  setLokalPlanerMapSearchResult: Function;
  hoveredLokalPlanerMapSearchResult: number;
  setHoveredLokalPlanerMapSearchResult: Function;
  lokalplanerLoading: boolean;
  setLokalplanerLoading: Function;
  bygOmfangFilter: IBygOmfangFilter;
  etagerByggeHojde: IEtagerByggehojdeFilter;
  activeStyle: ActiveStyle;
  setActiveStyle: Function;
  setClickedByggefelt: Function;
  setClickedDelomraade: Function;
  selectedKommune: IKommune;
  setHistoriskeLokalplaner: Function;
  setHistoriskeLokalplanerLoading: Function;
  setHistoriskeLokalplanerToggled: Function;
  setCurrentHistoriskeLokalplan: Function;
  currentHistoriskeLokalplan: ILokalplan;
  triggerHistoriskeLokalplaner: boolean;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MapContainer);
